    //三级联动
   const matterTree = (data) => {
        for (var i = 0; i < data.length; i++) {
            // 这里面就是你处理数据的地方 
            data[i].label = data[i].value
            delete data[i].pcode
            delete data[i].id
            if (data[i].children && data[i].children.length > 0) {
                // children若不为空数组，则继续 递归调用 本方法
                matterTree(data[i].children)
            }
        }
        return data
    }

    export default matterTree